// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flex {
  display: flex;
  width: 100%;
  gap: 10px;
  align-items: center;
  height: 38px;
  padding: 16px;
  transition: ease-in 0.2s;
}

.flex:hover {
  background: #fffbec;
  cursor: pointer;
  margin-left: 16px;
  margin-right: 16px;
  border-top-left-radius: 100px;
  border-bottom-left-radius: 100px;
  transition: ease-in 0.2s;
}

.active-item {
  --color: var(--ion-color-dark);
  background: #fffbec;
  font-weight: 600;
  margin-left: 16px;
  margin-right: 16px;
  transition: ease-in 0.2s;
  border-top-left-radius: 100px;
  border-bottom-left-radius: 100px;
  border-bottom: 1px solid var(--ion-color-primary);
}
.active-item ion-icon {
  color: var(--ion-color-dark) !important;
}

.central-loader {
  position: fixed;
  display: flex;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.2);
  z-index: 1050;
}

.central-loader > div {
  height: 42px;
  line-height: 40px;
  width: 200px;
  text-align: center;
  border: 2px #faf2cc solid;
  color: #8a6d3b;
  background-color: #fcf8e3;
  margin: auto;
}

a {
  font-size: 10px;
}

div > ion-icon {
  margin-top: 4px;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,wBAAA;AACF;;AACA;EACE,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,6BAAA;EACA,gCAAA;EACA,wBAAA;AAEF;;AAAA;EACE,8BAAA;EAEA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,wBAAA;EACA,6BAAA;EACA,gCAAA;EACA,iDAAA;AAEF;AAAE;EACE,uCAAA;AAEJ;;AACA;EACE,eAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,aAAA;AAEF;;AACA;EACE,YAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,yBAAA;EACA,YAAA;AAEF;;AACA;EACE,eAAA;AAEF;;AACA;EACE,eAAA;AAEF","sourcesContent":[".flex {\n  display: flex;\n  width: 100%;\n  gap: 10px;\n  align-items: center;\n  height: 38px;\n  padding: 16px;\n  transition: ease-in 0.2s;\n}\n.flex:hover {\n  background: #fffbec;\n  cursor: pointer;\n  margin-left: 16px;\n  margin-right: 16px;\n  border-top-left-radius: 100px;\n  border-bottom-left-radius: 100px;\n  transition: ease-in 0.2s;\n}\n.active-item {\n  --color: var(--ion-color-dark);\n  // background: #fefdfb;\n  background: #fffbec;\n  font-weight: 600;\n  margin-left: 16px;\n  margin-right: 16px;\n  transition: ease-in 0.2s;\n  border-top-left-radius: 100px;\n  border-bottom-left-radius: 100px;\n  border-bottom: 1px solid var(--ion-color-primary);\n  // border-bottom: 1px solid #f6f1eb;\n  ion-icon {\n    color: var(--ion-color-dark) !important;\n  }\n}\n.central-loader {\n  position: fixed;\n  display: flex;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.2);\n  z-index: 1050;\n}\n\n.central-loader > div {\n  height: 42px;\n  line-height: 40px;\n  width: 200px;\n  text-align: center;\n  border: 2px #faf2cc solid;\n  color: #8a6d3b;\n  background-color: #fcf8e3;\n  margin: auto;\n}\n\na {\n  font-size: 10px;\n}\n\ndiv > ion-icon {\n  margin-top: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
